import { RESULT_PROMPT } from './constants';

interface OverdraftCalculatorSummaryProps {
  savings: string;
}

/** The whole answer is one number, so the announcement carries the result rather than condensing it. */
export const OverdraftCalculatorSummary = ({ savings }: OverdraftCalculatorSummaryProps) => (
  <div className="text-center">
    <p className="text-body-saans">{RESULT_PROMPT}</p>
    <p className="mt-3 text-heading-md">{savings}</p>
  </div>
);
